import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'
import _imports_1 from '@/app/ui/assets/svg/notebook-slash-gray.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-082e249b")

_pushScopeId("data-v-082e249b")
const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = { class: "relative md:w-8/12 lg:w-5/12 flex flex-col h-screen bg-white" }
const _hoisted_3 = { class: "border-b py-4 border-gray-lp-400" }
const _hoisted_4 = { class: "px-8 inline-flex justify-between w-full" }
const _hoisted_5 = { class: "font-semibold text-20px mr-4" }
const _hoisted_6 = { class: "px-8 pt-4 overflow-auto pb-20" }
const _hoisted_7 = { class: "text-12px xxl:text-14px text-gray-lp-500" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_9 = { class: "flex flex-col my-4" }
const _hoisted_10 = { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }
const _hoisted_11 = { class: "inline-block relative z-10 w-full my-2 mr-4" }
const _hoisted_12 = { class: "flex flex-col my-4" }
const _hoisted_13 = { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }
const _hoisted_14 = { class: "flex flex-col my-4" }
const _hoisted_15 = { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300 mb-2" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "flex flex-col gap-2 overflow-auto h-full" }
const _hoisted_18 = {
  key: 1,
  class: "flex flex-col w-full py-20 items-center gap-4"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-10"
}, null, -1)
const _hoisted_20 = { class: "font-semibold text-12px" }
const _hoisted_21 = { class: "w-full z-20 absolute bottom-0 items-center flex flex-row rounded-b-md text-xs bg-gray-lp-700 justify-center md:justify-end px-8 py-4" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "opacity-50 fixed inset-0 z-30 bg-black" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_UploadFile = _resolveComponent("UploadFile")!
  const _component_RiwayatUploadFile = _resolveComponent("RiwayatUploadFile")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_button_fill = _resolveComponent("button-fill")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["justify-end items-center flex overflow-hidden fixed inset-0 z-40 outline-none focus:outline-none", {'pb-4': _ctx.isShowRunningText}]
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("managementCustomer.bulk.title")), 1),
            _createVNode("img", {
              src: _imports_0,
              class: "w-4 cursor-pointer",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCloseWithReset && _ctx.onCloseWithReset(...args))),
              alt: "x"
            })
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.$t("managementCustomer.bulk.description")) + " ", 1),
            _createVNode("span", {
              class: "text-red-lp-200 cursor-pointer",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.directTemplate && _ctx.directTemplate(...args)))
            }, _toDisplayString(_ctx.$t("managementCustomer.bulk.descriptionLink")), 1),
            _hoisted_8
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("managementCustomer.bulk.activityName")), 1),
            _createVNode("div", _hoisted_11, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.activityName = $event)),
                class: "block appearance-none text-12px xxl:text-14px w-full bg-white border border-gray-lp-400 px-4 py-2 xxl:py-2.5 pr-16 rounded shadow leading-tight focus:outline-none",
                maxlength: _ctx.maxActivityNameLength,
                placeholder: 
                  _ctx.$t('managementCustomer.bulk.activityNamePlaceholder')
                
              }, null, 8, ["maxlength", "placeholder"]), [
                [_vModelText, _ctx.activityName]
              ]),
              _createVNode("div", {
                class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-2 text-gray-lp-500 mr-2 text-12px",
                onClick: ($event: any) => (
                  {
                  }
                )
              }, _toDisplayString(_ctx.activityName.length) + "/" + _toDisplayString(_ctx.maxActivityNameLength), 1)
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("managementCustomer.bulk.uploadFile")), 1),
            _createVNode(_component_UploadFile, _mergeProps({
              modelValue: _ctx.archiveFile,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.archiveFile = $event)),
              isClear: _ctx.isClearFile,
              "onUpdate:isClear": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isClearFile = $event)),
              statusReset: _ctx.statusReset
            }, _ctx.configUploadFile, {
              archiveType: _ctx.archiveType,
              showInfoDraggable: false,
              caption: _ctx.$t('managementCustomer.bulk.uploadFileCaption')
            }), null, 16, ["modelValue", "isClear", "statusReset", "archiveType", "caption"])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("managementCustomer.bulk.historyTitle")), 1),
            (_ctx.bulkListData.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulkListData, (item, index) => {
                      return (_openBlock(), _createBlock(_component_RiwayatUploadFile, {
                        key: index,
                        data: item
                      }, null, 8, ["data"]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.bulkListData.length === 0)
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("managementCustomer.bulk.historyEmpty")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode(_component_button_outline, {
            custom: "bg-white px-12 border border-red-lp-100 text-red-lp-200 mr-4",
            title: _ctx.$t('managementCustomer.bulk.cancel'),
            onClick: _ctx.onCloseWithReset
          }, null, 8, ["title", "onClick"]),
          _createVNode(_component_button_fill, {
            custom: "px-12 bg-red-lp-200",
            title: _ctx.$t('managementCustomer.bulk.submit'),
            onClick: _ctx.onSubmit,
            isLoading: _ctx.isLoading,
            isDisabled: _ctx.isDisabled
          }, null, 8, ["title", "onClick", "isLoading", "isDisabled"])
        ])
      ])
    ], 2),
    _hoisted_22
  ]))
})